import React, { useEffect, useRef, useState } from 'react'
import Fade from '@material-ui/core/Fade';
import Checkbox from '@material-ui/core/Checkbox';
import Snackbar from '@material-ui/core/Snackbar';
import { activateCustomer, deactivateCustomer, updateCustomer } from '../../../../actions/customerActions';

const CustomerInfo = ({ match, dataCustomer, bankId, onRefetch }) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [deactivating, setDeactivating] = useState(false);
    const [activating, setActivating] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [fieldSaving, setFieldSaving] = useState({ terms_accepted: false, email_confirmed: false });
    const listInputs = useRef(null);

    const handleDeactivate = async () => {
        if (!window.confirm('Are you sure you want to deactivate this user?')) return;
        setDeactivating(true);
        await deactivateCustomer(data?.id, bankId);
        await onRefetch?.();
        setDeactivating(false);
        setSnackbarMessage('User deactivated successfully');
        setSnackbarOpen(true);
    };

    const handleActivate = async () => {
        if (!window.confirm('Are you sure you want to activate this user?')) return;
        setActivating(true);
        await activateCustomer(data?.id, bankId);
        await onRefetch?.();
        setActivating(false);
        setSnackbarMessage('User activated successfully');
        setSnackbarOpen(true);
    };

    const handleToggleField = async (field, checked, label) => {
        if (!window.confirm(`Are you sure you want to set "${label}" to ${checked ? 'Yes' : 'No'}?`)) return;
        setFieldSaving(prev => ({ ...prev, [field]: true }));
        await updateCustomer(data?.id, { [field]: checked }, bankId);
        setData(prev => ({ ...prev, [field]: checked }));
        setFieldSaving(prev => ({ ...prev, [field]: false }));
        setSnackbarMessage(`${label} updated successfully`);
        setSnackbarOpen(true);
    };


    useEffect(() => {
        if (dataCustomer && Object.values(dataCustomer).length > 0) {
            setData(dataCustomer);
            setLoading(false);
        }
    }, [dataCustomer]);


    return (
        <div className='col-12 col-lg-12'>
            <div className='card'>
                <div className="card-header">
                    <i className="fa fa-align-justify"></i> Customer details
                </div>

                <div className='card-body customerrr'>
                    <div className='row'>
                        <div className="col-12">
                            <fieldset className="p-2 pb-5 pl-5 pr-5">
                                <legend className="d-inline">User Details</legend>
                                <div>
                                    {Object.values(data).length > 0 ? (
                                        <div ref={listInputs} className="row">
                                            {/* Перша колонка */}
                                            <div className="col-md-6">
                                                <div className="mb-3 flex align-items-center">
                                                    <label className="form-label mb-0">Active</label>
                                                    <div>
                                                        <Checkbox
                                                            name={'active'}
                                                            disabled
                                                            checked={!!data?.active}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">ID</label>
                                                    <input className="form-control" readOnly name="id" type='number' defaultValue={data?.id}></input>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">GUID</label>
                                                    <input className="form-control" name="guid" readOnly type='number' defaultValue={data?.guid}></input>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Username</label>
                                                    <input className="form-control" readOnly name="username" type='text' defaultValue={(data?.email)}></input>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Name</label>
                                                    <input className="form-control" readOnly name="name" type='text' defaultValue={data?.profile?.first_name && data?.profile?.last_name
                                                        ? data?.profile?.first_name +
                                                        " " +
                                                        data?.profile?.last_name
                                                        : data?.profile?.first_name
                                                            ? data?.profile?.first_name
                                                            : data?.profile?.last_name || "-"}></input>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Alias</label>
                                                    <input className="form-control" readOnly name="alias" type="text" defaultValue={data?.bank_account?.username}></input>
                                                </div>

                                                <div className="mb-0 flex align-items-center">
                                                    <label className="form-label mb-0">Terms Accepted</label>
                                                    <div>
                                                        <Checkbox
                                                            name={'terms_accepted'}
                                                            checked={!!data?.terms_accepted}
                                                            disabled={fieldSaving.terms_accepted}
                                                            onChange={(e) => handleToggleField('terms_accepted', e.target.checked, 'Terms Accepted')}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mb-3 flex align-items-center">
                                                    <label className="form-label mb-0">Email Confirmed</label>
                                                    <div>
                                                        <Checkbox
                                                            name={'email_confirmed'}
                                                            checked={!!data?.email_confirmed}
                                                            disabled={fieldSaving.email_confirmed}
                                                            onChange={(e) => handleToggleField('email_confirmed', e.target.checked, 'Email Confirmed')}
                                                        />
                                                    </div>
                                                </div>
                                                {data?.active && (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <button
                                                            type="button"
                                                            className="btn text-nowrap"
                                                            style={{ backgroundColor: '#f86c6b', borderColor: '#f86c6b', color: '#fff' }}
                                                            onClick={handleDeactivate}
                                                            disabled={deactivating}
                                                        >
                                                            {deactivating ? 'Deactivating...' : 'Deactivate'}
                                                        </button>
                                                    </div>
                                                )}
                                                {!data?.active && (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <button
                                                            type="button"
                                                            className="btn text-nowrap"
                                                            style={{ backgroundColor: '#4dbd74', borderColor: '#4dbd74', color: '#fff' }}
                                                            onClick={handleActivate}
                                                            disabled={activating}
                                                        >
                                                            {activating ? 'Activating...' : 'Activate'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                                <div className="mb-3 flex align-items-center">
                                                    <label className="form-label mb-0">Member</label>
                                                    <div>
                                                        <Checkbox
                                                            disabled
                                                            name={'membership'}
                                                            defaultChecked={data?.membership}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Create at</label>
                                                    <input className="form-control" readOnly name="created_at" type="date" defaultValue={data?.created_at?.split('T')[0]}></input>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Update at</label>
                                                    <input className="form-control" readOnly name="updated_at" type="date" defaultValue={data?.updated_at?.split('T')[0]}></input>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Gender</label>
                                                    <select disabled className="form-control" name="gender" defaultValue={data?.profile?.gender}>
                                                        <option value="" disabled>Choose Gender</option>
                                                        <option value={'male'}>male</option>
                                                        <option value={'female'}>female</option>
                                                    </select>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Birthday</label>
                                                    <input className="form-control" type="date" readOnly name="birthday" defaultValue={data?.profile?.birthday?.split('T')[0]}></input>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>



                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                />

                <Fade in={loading} mountOnEnter unmountOnExit>
                    <span style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        marginLeft: 150,
                        color: 'black',
                        background: 'white',
                        zIndex: 100,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 40,
                        textAlign: 'center'
                    }}>Loading ...</span>
                </Fade>
            </div>
        </div>

    )
}

export default CustomerInfo;